import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import encryptor from "./encryptor";
import createCompressor from "redux-persist-transform-compress";
import { appslice } from "./app";
import { userslice } from "./user";
import { productSlice } from "./product";
import { orderSlice } from "./order";
import { categorySlice } from "./category";
import { shippingSlice } from "./shipping";
import { subscriptionSlice } from "./subscription";
import { postSlice } from "./post";
import { fileSlice } from "./file";
import { couponSlice } from "./coupon";
import { contactSlice } from "./contact";
import { apiKeySlice } from "./api-key";
import { affiliateSlice } from "./affiliate";
import { quoteSlice } from "./quote";
import { refundRequestSlice } from "./refund-request";
import { notificationSlice } from "./notification";

const reducers = combineReducers({
  app: appslice.reducer,
  user: userslice.reducer,
  product: productSlice.reducer,
  order: orderSlice.reducer,
  category: categorySlice.reducer,
  shipping: shippingSlice.reducer,
  subscription: subscriptionSlice.reducer,
  post: postSlice.reducer,
  file: fileSlice.reducer,
  coupon: couponSlice.reducer,
  contact: contactSlice.reducer,
  apiKey: apiKeySlice.reducer,
  affiliate: affiliateSlice.reducer,
  quote: quoteSlice.reducer,
  refundRequest: refundRequestSlice.reducer,
  notification: notificationSlice.reducer,
});

const resetRootReducer = (state, action) => {
  if (action.type === "user/logOutAction") {
    return reducers({ product: {}, app: {} }, action);
  }
  return reducers(state, action);
};
const compressor = createCompressor();

const config = {
  blacklist: ["app", "network", "toast"],
  key: "primary-1",
  storage,
  transforms: [encryptor, compressor],
};

export const persistedReducer = persistReducer(config, resetRootReducer);
